import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import Table from '@amzn/awsui-components-react/polaris/table';
import Box from '@amzn/awsui-components-react/polaris/box';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import { useAnalyticsData } from '../../../hooks';

const LanguageStats: React.FC = () => {
  const { data, loading, error } = useAnalyticsData();

  if (loading) {
    return (
      <Container>
        <Box textAlign="center" padding="l">
          <Spinner />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box color="text-status-error" textAlign="center" padding="l">
          Error loading language data
        </Box>
      </Container>
    );
  }

  const languageStats = (data && data.languageStats) || [];

  return (
    <Container
      header={
        <Header variant="h2">
          Language Statistics
        </Header>
      }
    >
      {languageStats.length > 0 ? (
        <Table
          columnDefinitions={[
            {
              id: 'language',
              header: 'Language',
              cell: (item) => item.language || 'Unknown'
            },
            {
              id: 'transcriptionCount',
              header: 'Transcriptions',
              cell: (item) => item.transcriptionCount.toLocaleString()
            },
            {
              id: 'translationCount',
              header: 'Translations',
              cell: (item) => item.translationCount.toLocaleString()
            },
            {
              id: 'successRate',
              header: 'Success Rate',
              cell: (item) => `${item.successRate}%`
            }
          ]}
          items={languageStats}
          loadingText="Loading language statistics..."
          empty={
            <Box textAlign="center" color="inherit">
              <b>No language statistics available</b>
            </Box>
          }
        />
      ) : (
        <Box textAlign="center" color="text-status-inactive" padding="l">
          No language statistics available
        </Box>
      )}
    </Container>
  );
};

export default LanguageStats;
